<template>
  <v-flex mt-3 main-section>
    <OvationsPoints></OvationsPoints>
    <UpcomingEvents></UpcomingEvents>
    <EngagementLeaders></EngagementLeaders>
  </v-flex>
</template>

<script>
import OvationsPoints from "@/components/OvationsPoints";
import UpcomingEvents from "@/components/UpcomingEvents";
import EngagementLeaders from "@/components/EngagementLeaders";

export default {
  name: "DashboardSidebar",
  components: {
    OvationsPoints,
    UpcomingEvents,
    EngagementLeaders,
  },
  data() {
    return {};
  },
};
</script>
